import React from 'react';
import { connect } from 'react-redux';
import { updateOptionsForPrint } from 'util/renderOptions';
import * as chartCrops from '../../../reducers/chartCrops';
import InnerChartPrint from './InnerChartPrint';

const NewEnginePrintCrop = ({ id, chart, options, updateChartCrops }) => {
  const { series } = chart.data;
  const size = chart.sizes[id];

  // for static charts use predefined width/height (size)
  const sizeOptions = updateOptionsForPrint({ options, size, id });
  updateChartCrops(id, { sizeOptions, size });

  return series && series.length ? (
    <InnerChartPrint sizeOptions={sizeOptions} chart={chart} />
  ) : null;
};

const mapDispatchToProps = {
  updateChartCrops: chartCrops.updateChartCrops,
};

export default connect(null, mapDispatchToProps)(NewEnginePrintCrop);
